import HttpService from "@/services/HttpService";
import store from "@/store/index";

let globalGeofenceStatusCache = null;
let globalGeofenceStatusPromise = null;
let googleMapsApiKeyCache = null;

const normalizeCollection = (response) => {
  const payload = response?.data;
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  return [];
};

const normalizeItem = (response) => {
  const payload = response?.data;
  if (!payload) return null;
  if (payload?.data && !Array.isArray(payload.data)) return payload.data;
  return payload;
};

const GeoFencingService = {
  async getGlobalGeofenceStatus({ forceRefresh = false } = {}) {
    const userPermissions =
      store?.state?.auth?.user?.permission?.map((el) => el.name) || [];
    if (!userPermissions.includes("geofencing-get-global-geofence-status")) {
      return 0;
    }

    if (!forceRefresh && globalGeofenceStatusCache !== null) {
      return globalGeofenceStatusCache;
    }

    if (!forceRefresh && globalGeofenceStatusPromise) {
      return globalGeofenceStatusPromise;
    }

    globalGeofenceStatusPromise = HttpService.get("/get-global-geofence-status")
      .then((response) => {
        const status =
          Number(response?.data?.data.has_geofence ?? response?.data.has_geofence ?? 0) === 1 ? 1 : 0;
        globalGeofenceStatusCache = status;
        console.log("GeoFencingService: getGlobalGeofenceStatus", status);
        return status;
      })
      .finally(() => {
        globalGeofenceStatusPromise = null;
      });

    return globalGeofenceStatusPromise;
  },

  async updateGlobalGeofenceStatus(hasGeofence, googleKey) {
    const value = Number(hasGeofence) === 1 ? 1 : 0;
    const payload = { has_geofence: value };
    if (googleKey !== undefined) payload.google_key = googleKey;
    const response = await HttpService.post("/update-global-geofence-status", payload);
    globalGeofenceStatusCache = value;
    return response;
  },

  async getGoogleMapsApiKey() {
    const response = await HttpService.get("/google-key");
    return response?.data?.data ?? null;
  },

  async verifyGoogleKey(apiKey) {
    const response = await HttpService.post("/verify-google-key", { google_key: apiKey });
    return response?.data;
  },

  async testGoogleMapsApiKey(apiKey) {
    const response = await HttpService.post("/test-google-maps-api-key", { api_key: apiKey });
    return response?.data;
  },

  async saveGoogleMapsApiKey(apiKey) {
    const response = await HttpService.post("/save-google-maps-api-key", { api_key: apiKey });
    googleMapsApiKeyCache = apiKey;
    if (globalGeofenceStatusCache) {
      globalGeofenceStatusCache = { ...globalGeofenceStatusCache, has_api_key: true };
    }
    return response?.data;
  },

  // async getGoogleMapsApiKey() {
  //   if (googleMapsApiKeyCache) return googleMapsApiKeyCache;
  //   const response = await HttpService.get("/get-google-maps-api-key");
  //   const key = response?.data?.data?.api_key ?? response?.data?.api_key ?? null;
  //   googleMapsApiKeyCache = key;
  //   return key;
  // },

  async list(params = {}) {
    // Prefer paginated endpoint when filters/pagination are provided.
    if (params && Object.keys(params).length) {
      const paginatedResponse = await HttpService.get("/geofence-paginated", {
        params,
      });
      return normalizeCollection(paginatedResponse);
    }

    const response = await HttpService.get("/geofence");
    return normalizeCollection(response);
  },

  async getById(id) {
    const response = await HttpService.get(`/geofence/${id}/edit`);
    return normalizeItem(response);
  },

  async create(payload) {
    const response = await HttpService.post("/geofence", payload);
    return normalizeItem(response);
  },

  async update(id, payload) {
    const response = await HttpService.put(`/geofence/${id}`, payload);
    return normalizeItem(response);
  },

  async delete(id) {
    return HttpService.delete(`/geofence/${id}`);
  },

  async getGeofenceDepartments() {
    const response = await HttpService.get("/get-geofence-departments");
    return normalizeCollection(response);
  },

  async getGeofenceDivisions() {
    const response = await HttpService.get("/get-geofence-divisions");
    return normalizeCollection(response);
  },

  async getGeofenceShifts() {
    const response = await HttpService.get("/get-geofence-shifts");
    return normalizeCollection(response);
  },

  async getGeofenceEmployees() {
    const response = await HttpService.get("/get-geofence-employees");
    return normalizeCollection(response);
  },

  async assignGeofence(payload) {
    return HttpService.post("/assign-geofence", payload);
  },

  async unassignGeofence(payload) {
    return HttpService.post("/unassign-geofence", payload);
  },

  async getGeofenceAssignments(params = {}) {
    const response = await HttpService.get("/get-geofence-assignments", {
      params,
    });
    return {
      rows: normalizeCollection(response),
      pagination: response?.data?.pagination || response?.data?.data?.pagination || null,
    };
  },
};

export default GeoFencingService;
